export default {
  id: '1a3e303881',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page rt" data-name="returns">\n\n    <!-- Navbar -->\n    <div class="navbar rt__navbar no-shadow">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="left">\n          <a href="#" class="link back rt__back" aria-label="Back">\n            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>\n          </a>\n        </div>\n        <div class="title rt__navbar-title">Daily Profits</div>\n        <div class="right"></div>\n      </div>\n    </div>\n\n    <div class="page-content rt__content">\n\n      <!-- Summary hero -->\n      <div class="rt__hero">\n        <span class="rt__hero-glow"></span>\n        <span class="rt__hero-grid"></span>\n        <div class="rt__hero-top">\n          <span class="rt__hero-ico">\n            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>\n          </span>\n          <span class="rt__hero-tag"><span class="rt__hero-tag-dot"></span>Daily ROI</span>\n        </div>\n        <div class="rt__hero-label">Total Profit Received</div>\n        <div class="rt__hero-amount rt-total">$0.00</div>\n        <div class="rt__hero-stats">\n          <div class="rt__hero-stat">\n            <span class="rt__hero-stat-ico"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6 9 17l-5-5"/></svg></span>\n            <div>\n              <span class="rt__hero-stat-val rt-count">0</span>\n              <span class="rt__hero-stat-lbl">Payouts</span>\n            </div>\n          </div>\n          <span class="rt__hero-divider"></span>\n          <div class="rt__hero-stat">\n            <span class="rt__hero-stat-ico"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg></span>\n            <div>\n              <span class="rt__hero-stat-val rt-last">\u2014</span>\n              <span class="rt__hero-stat-lbl">Last Payout</span>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!-- Filter segmented control -->\n      <div class="rt__filters">\n        <button type="button" class="rt__filter rt__filter--on" data-rt="all">All</button>\n        <button type="button" class="rt__filter" data-rt="return">Profits</button>\n        <button type="button" class="rt__filter" data-rt="refund">Refunds</button>\n        <span class="rt__filter-pill"></span>\n      </div>\n\n      <!-- History -->\n      <div class="rt__list"></div>\n      <div class="rt__end-gap"></div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  style: `
/* ════════ DAILY PROFITS / RETURNS (rt__*) ════════ */
.rt { background: #0A0A0B !important; }
.rt__content {
  background:
    radial-gradient(130% 42% at 50% 0%, rgba(74,222,128,0.09) 0%, transparent 56%),
    radial-gradient(120% 40% at 50% 0%, rgba(201,169,105,0.08) 0%, transparent 52%),
    #0A0A0B !important;
  padding: 15px 14px calc(40px + env(safe-area-inset-bottom)) !important;
  margin-top: 60px !important;
}
.rt__navbar { background: linear-gradient(180deg, #100E09 0%, #0B0A07 100%) !important; }
.rt__navbar:after { display: none !important; }
.rt__navbar .navbar-bg { background: transparent !important; }
.rt__navbar-title { color: var(--gold) !important; font-weight: 700; }
.rt__back { color: rgba(201,169,105,0.85) !important; }

/* ── Summary hero ── */
.rt__hero {
  position: relative; overflow: hidden;
  border-radius: 22px; padding: 20px;
  background:
    radial-gradient(100% 100% at 100% 0%, rgba(74,222,128,0.14) 0%, transparent 52%),
    linear-gradient(150deg, #14180f 0%, #101109 55%, #121310 100%);
  border: 1px solid rgba(74,222,128,0.2);
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.06), 0 16px 36px -18px rgba(0,0,0,0.8);
}
.rt__hero-glow {
  position: absolute; top: -55px; right: -35px; width: 170px; height: 170px; border-radius: 50%;
  pointer-events: none; background: radial-gradient(circle, rgba(74,222,128,0.18), transparent 65%);
}
.rt__hero-grid {
  position: absolute; inset: 0; pointer-events: none; opacity: 0.5;
  background-image: linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px);
  background-size: 26px 26px;
  -webkit-mask-image: radial-gradient(120% 90% at 100% 0%, #000 0%, transparent 70%);
  mask-image: radial-gradient(120% 90% at 100% 0%, #000 0%, transparent 70%);
}
.rt__hero-top { position: relative; z-index: 1; display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
.rt__hero-ico {
  width: 42px; height: 42px; border-radius: 13px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  background: rgba(74,222,128,0.12); border: 1px solid rgba(74,222,128,0.3); color: #4ade80;
}
.rt__hero-tag {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 4px 10px; border-radius: 20px;
  background: rgba(74,222,128,0.1); border: 1px solid rgba(74,222,128,0.24);
  font-size: 10px; font-weight: 700; color: #4ade80; text-transform: uppercase; letter-spacing: 0.04em;
}
@keyframes rt-pulse { 0%,100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.4; transform: scale(0.75); } }
.rt__hero-tag-dot { width: 6px; height: 6px; border-radius: 50%; background: #4ade80; animation: rt-pulse 1.6s ease-in-out infinite; }
.rt__hero-label { position: relative; z-index: 1; font-size: 11px; font-weight: 500; color: rgba(255,255,255,0.45); text-transform: uppercase; letter-spacing: 0.04em; }
.rt__hero-amount { position: relative; z-index: 1; font-size: 34px; font-weight: 800; color: #4ade80; letter-spacing: -0.02em; line-height: 1; margin: 8px 0 0; }
.rt__hero-stats { position: relative; z-index: 1; display: flex; align-items: center; gap: 14px; margin-top: 18px; padding-top: 15px; border-top: 1px solid rgba(255,255,255,0.07); }
.rt__hero-stat { display: flex; align-items: center; gap: 9px; }
.rt__hero-stat-ico { width: 26px; height: 26px; border-radius: 8px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); color: rgba(255,255,255,0.6); }
.rt__hero-stat-val { display: block; font-size: 16px; font-weight: 800; color: #fff; line-height: 1.1; }
.rt__hero-stat-lbl { display: block; font-size: 10px; color: rgba(255,255,255,0.42); text-transform: uppercase; letter-spacing: 0.03em; margin-top: 1px; }
.rt__hero-divider { width: 1px; height: 28px; background: rgba(255,255,255,0.1); }

/* ── Segmented filter ── */
.rt__filters {
  position: relative; display: flex; gap: 0; margin: 16px 0 16px; padding: 4px;
  border-radius: 14px; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.06);
}
.rt__filter {
  position: relative; z-index: 1; flex: 1; height: 38px; border: none; background: transparent; cursor: pointer;
  font-size: 12.5px; font-weight: 700; color: rgba(255,255,255,0.5); border-radius: 10px;
  transition: color .2s ease;
}
.rt__filter--on { color: #0c1c12; }
.rt__filter-pill {
  position: absolute; z-index: 0; top: 4px; left: 4px; height: 38px; border-radius: 10px;
  width: calc((100% - 8px) / 3);
  background: linear-gradient(135deg, #5fe892 0%, #3fbf76 100%);
  box-shadow: 0 6px 16px -6px rgba(74,222,128,0.6);
  transition: transform .28s cubic-bezier(.34,1.3,.5,1);
}
.rt__filters[data-active="return"] .rt__filter-pill { transform: translateX(100%); }
.rt__filters[data-active="refund"] .rt__filter-pill { transform: translateX(200%); }
.rt__filters[data-active="refund"] .rt__filter-pill { background: linear-gradient(135deg, #efd79a 0%, #C9A969 100%); box-shadow: 0 6px 16px -6px rgba(201,169,105,0.6); }

/* ── Day group ── */
.rt__group { margin-bottom: 18px; }
.rt__group-date {
  display: flex; align-items: center; gap: 8px; margin: 0 2px 10px;
  font-size: 11px; font-weight: 700; color: rgba(255,255,255,0.55); letter-spacing: 0.02em; text-transform: uppercase;
}
.rt__group-date:before { content: ''; width: 6px; height: 6px; border-radius: 2px; background: rgba(201,169,105,0.6); }
.rt__group-sum {
  margin-left: auto; font-size: 11px; font-weight: 800; color: #4ade80; letter-spacing: 0.01em;
  padding: 3px 9px; border-radius: 20px; background: rgba(74,222,128,0.1); border: 1px solid rgba(74,222,128,0.22);
  text-transform: none;
}

/* ── Return row ── */
.rt__row {
  position: relative; overflow: hidden;
  display: flex; align-items: center; gap: 12px; padding: 13px 14px 13px 16px; margin-bottom: 9px;
  background: linear-gradient(155deg, rgba(255,255,255,0.035) 0%, rgba(255,255,255,0.008) 100%), #111110;
  border: 1px solid rgba(255,255,255,0.07); border-radius: 16px;
  transition: transform .12s ease, border-color .16s ease;
}
.rt__row:active { transform: scale(0.992); }
.rt__row:before { content: ''; position: absolute; left: 0; top: 14px; bottom: 14px; width: 3px; border-radius: 0 3px 3px 0; background: rgba(255,255,255,0.12); }
.rt__row--return:before { background: #4ade80; }
.rt__row--refund:before { background: #dfc288; }
.rt__row-ico {
  width: 40px; height: 40px; border-radius: 12px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
}
.rt__row-ico--return { background: rgba(74,222,128,0.12); border: 1px solid rgba(74,222,128,0.26); color: #4ade80; }
.rt__row-ico--refund { background: rgba(201,169,105,0.12); border: 1px solid rgba(201,169,105,0.26); color: #dfc288; }
.rt__row-body { flex: 1; min-width: 0; }
.rt__row-title { font-size: 13.5px; font-weight: 700; color: #fff; }
.rt__row-meta { display: flex; align-items: center; gap: 7px; margin-top: 4px; flex-wrap: wrap; }
.rt__row-ref { font-size: 11px; color: rgba(255,255,255,0.4); font-weight: 600; }
.rt__row-roi {
  font-size: 10px; font-weight: 700; padding: 2px 7px; border-radius: 6px;
  background: rgba(201,169,105,0.12); color: #dfc288;
}
.rt__row-right { text-align: right; flex-shrink: 0; }
.rt__row-amt { font-size: 15px; font-weight: 800; color: #4ade80; line-height: 1.1; }
.rt__row-amt--muted { color: rgba(255,255,255,0.55); }
.rt__row-status { display: inline-flex; align-items: center; gap: 4px; font-size: 10px; font-weight: 700; margin-top: 4px; }
.rt__row-status-dot { width: 5px; height: 5px; border-radius: 50%; }
.rt__row-status--success { color: #4ade80; }
.rt__row-status--success .rt__row-status-dot { background: #4ade80; }
.rt__row-status--pending { color: #fbbf24; }
.rt__row-status--pending .rt__row-status-dot { background: #fbbf24; }
.rt__row-status--failed { color: #ff6b5c; }
.rt__row-status--failed .rt__row-status-dot { background: #ff6b5c; }

/* ── Empty state ── */
.rt__empty { text-align: center; padding: 48px 24px; }
.rt__empty-ico {
  width: 66px; height: 66px; border-radius: 50%; margin: 0 auto 16px;
  background: rgba(74,222,128,0.07); border: 1px solid rgba(74,222,128,0.18); color: rgba(74,222,128,0.7);
  display: flex; align-items: center; justify-content: center;
}
.rt__empty-title { font-size: 15px; font-weight: 700; color: rgba(255,255,255,0.85); margin: 0; }
.rt__empty-sub { font-size: 12.5px; color: rgba(255,255,255,0.45); margin: 7px auto 0; line-height: 1.55; max-width: 280px; }

.rt__skeleton { height: 66px; border-radius: 15px; margin-bottom: 9px; background: linear-gradient(100deg, #141312 30%, #1c1a17 50%, #141312 70%); background-size: 200% 100%; animation: rt-shimmer 1.3s infinite; }
@keyframes rt-shimmer { to { background-position: -200% 0; } }

.rt__end-gap { height: 30px; }
`,
  styleScoped: false
};